import { Component } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ScreenSizeService } from '../../../../../../services/utils/screenSize.service';

@Component({
    selector: 'app-clinic-list-item-skeleton',
    templateUrl: './clinic-list-item-skeleton.component.html',
    styleUrls: ['./clinic-list-item-skeleton.component.scss'],
    animations: [
        trigger('cardAnimation', [
            state('hidden', style({ opacity: 0, transform: 'translateY(20px)' })),
            state('visible', style({ opacity: 1, transform: 'translateY(0)' })),
            transition('hidden => visible', [animate('100ms ease-out')]),
        ]),
    ],
    standalone: false
})
export class ClinicListItemSkeletonComponent {

  rating = 3.5;
  averageRating = 8.5;
  reviewCount = 132;

  constructor(
    protected screenSize: ScreenSizeService,
  ) { }

  animationState: 'hidden' | 'visible' = 'hidden';

  ngOnInit() {
    setTimeout(() => {
      this.animationState = 'visible';
    }, 100);

  }
}